import { 
    RESET_FITRAH_DATA , 
    UPDATE_ZAKAT_CALC_FITRAH_DATA , 
    GET_ZAKAT_DATA , 
    UPDATE_TOTAL_CALC , 
    UPDATE_GOLD_DATA , 
    UPDATE_INSURANCE_DATA , 
    RESET_GOLD_DATA ,
    UPDATE_GOLD_DATA_IN_USE ,
    UPDATE_GOLD_DATA_NOT_IN_USE,
    UPDATE_SHARES_DATA,
    UPDATE_SAVINGS_DATA,
    ADD_NEW_SHARES_DATA,
    REMOVE_SHARES_DATA,
    REMOVE_INSURANCE_DATA,
    ADD_NEW_INSURANCE_DATA,
    UPDATE_INSURANCE_SOURCE_TYPE,
    UPDATE_SAVINGS_SOURCE_TYPE,
    UPDATE_GOLD_SOURCE_TYPE,
    REINITIALIZE_INSURANCE_DATA,
    UPDATE_NISAB_VALUE,
    ADD_NEW_SAVINGS_DATA,
    REINITIALIZE_SAVINGS_DATA,
    REMOVE_SAVINGS_DATA,
    UPDATE_SHARES_SOURCE_TYPE,
    REINITIALIZE_SHARES_DATA,
    UPDATE_BUSINESS_DATA,
    SUBMITTING_ZAKAT_CALC_FORM,
    UPDATE_SOURCE_OF_INCOME_CALC,
    ZAKAT_CALC_PURGE,
    UPDATE_BUSINESS_AMOUNT
} from '../constants';

/* ==== FITRAH ==== */

export function updateZakatCalcFitrahData(fitrahType, data) {
    return {
      type: UPDATE_ZAKAT_CALC_FITRAH_DATA,
      payload: { fitrahType, data },
    };
  }

export function resetFitrahData() {
    return {
        type: RESET_FITRAH_DATA,
    }
}

/* ==== SAVINGS ==== */

export function reinitializeSavingData(){
    return {
        type: REINITIALIZE_SAVINGS_DATA
    }
}

export function addNewSavingData(){
    return {
        type: ADD_NEW_SAVINGS_DATA
    }
}

export function updateSavingsData(index, amount, interest, remark){
    return {
        type: UPDATE_SAVINGS_DATA,
        payload: { index: index, amount: amount || 0, interest: interest || 0 , remark: remark || '' }
    }
}

export function updateSavingsSourceType(sourceType) {
    return {
        type: UPDATE_SAVINGS_SOURCE_TYPE,
        payload:{ 
            sourceType,
        }
    }
}

export function removeSavingData(index) {
    return {
        type: REMOVE_SAVINGS_DATA,
        payload: { index }
    }
}

/* ==== GOLD ==== */

export function updateGoldData(gold){
    return {
        type: UPDATE_GOLD_DATA,
        gold
    }
}

export function updateGoldDataInUse(weightgrms, totalzakat){
    return {
        type: UPDATE_GOLD_DATA_IN_USE,
        payload: {
            weightgrms: weightgrms || 0, 
            totalzakat: totalzakat || 0
        }
    }
}

export function updateGoldDataNotInUse(weightgrms, totalzakat){
    return {
        type: UPDATE_GOLD_DATA_NOT_IN_USE,
        payload: {
            weightgrms: weightgrms || 0, 
            totalzakat: totalzakat || 0
        }
    }
}

export function updateGoldSourceType(sourceType) {
    return {
        type: UPDATE_GOLD_SOURCE_TYPE,
        payload: {
            sourceType,
        }
    }
}

export function resetGoldData() {
    return {
        type: RESET_GOLD_DATA,
    }
}

/* ==== INSURANCE ==== */

export function reinitializeInsuranceData(){
    return {
        type: REINITIALIZE_INSURANCE_DATA,
    }
}

export function addNewInsuranceData(){
    return {
        type: ADD_NEW_INSURANCE_DATA,
    }
}


export function updateInsuranceData(index,type, amount, remark){
    return {
        type: UPDATE_INSURANCE_DATA,
        payload: { index, type, amount: amount || 0 ,remark: remark || '' }
    }
}

export function removeInsuranceData(index){
    return {
        type: REMOVE_INSURANCE_DATA,
        payload: { index }
    }
}

export function updateInsuranceSourceType(sourceType) {
    return {
        type: UPDATE_INSURANCE_SOURCE_TYPE,
        payload: {
            sourceType,
        }
    }
}

/* ==== SHARES ==== */

export function reinitializeSharesData(){
    return {
        type: REINITIALIZE_SHARES_DATA,
    }
}

export function addNewSharesData(){
    return {
        type: ADD_NEW_SHARES_DATA,
    }
}

export function updateSharesData(index, amount, remark){
    return {
        type: UPDATE_SHARES_DATA,
        payload: {
            index,
            amount: amount || 0,
            remark: remark || ''
        }
    }
}

export function removeSharesData(index){
    return {
        type: REMOVE_SHARES_DATA,
        payload: {
            index
        }
    }
}

export function updateSharesSourceType(sourceType) {
    return {
        type: UPDATE_SHARES_SOURCE_TYPE,
        payload: {
            sourceType,
        }
    }
}


/* ==== BUSINESS ==== */

export function updateBusinessData(data) {
    return {
        type: UPDATE_BUSINESS_DATA,
        payload: { data }
    }
}

/* ==== COMMONS ==== */

export function submittingZakatCalcForm(data = true) {
    return {
        type: SUBMITTING_ZAKAT_CALC_FORM,
        payload: { data }
    }
}

export function updateNisabValue(value){
    return {
        type: UPDATE_NISAB_VALUE,
        payload: { value: value || 0 }
    }
}


export function updateTotal(total) {
    return {
        type: UPDATE_TOTAL_CALC,
        total
    }
}

export function getZakatCalcData(){
    return {
        type: GET_ZAKAT_DATA,
    }
}

export function resetZakatCalcData(){
    return {
        type: ZAKAT_CALC_PURGE,
    }
}

export function updateSourceOfIncome(source) {
    return {
        type: UPDATE_SOURCE_OF_INCOME_CALC,
        source
    }
  }

export const updateBusinessAmount = (amount) => ({
    type: UPDATE_BUSINESS_AMOUNT,
    payload: amount
});

  